module.exports = __webpack_public_path__ + "img/miyauchi-renge.4530c7c1.jpg";